'use client';
import { useState } from 'react';
import { 
  FaBitcoin, 
  FaMobile, 
  FaGlobe, 
  FaPalette,
  FaBrain,
  FaWifi,
  FaSalesforce,
  FaBug,
  FaGamepad,
  FaChevronRight,
  FaArrowRight
} from 'react-icons/fa';

const services = [
  {
    title: 'Blockchain Development Services',
    description:"Empowering Future-Ready Solutions with Blockchain Technology. At Infograins, we specialize in cutting-edge blockchain development services tailored to help businesses innovate, streamline operations, and achieve digital trust. Counted among the top blockchain development companies in Dubai, we deliver transformative solutions that drive efficiency and security. From smart contract development to private blockchain solutions and DeFi applications, we craft secure, scalable, and efficient decentralized systems that align with your business goals.",
    icon: <FaBitcoin />,
    color: 'orange',
    link: '/blockchain-development',
  },
  {
    title: 'Mobile Development Services',
    description:
      'Building Scalable, User-Centric Mobile Applications. At Infograins, we deliver next-gen mobile development services designed to elevate user engagement, drive business growth, and optimize performance across iOS and Android platforms. From native app development to cross-platform solutions and mobile UI/UX design, our expert team creates high-performing, feature-rich mobile experiences tailored to your vision.',
    icon: <FaMobile />,
    color: 'orange',
    link: '/mobile-development',
  },
  {
    title: 'Web Development Services',
    description:
      'Building Scalable, User-Centric Web Experiences. At Infograins, we offer innovative web development services designed to transform ideas into dynamic, responsive, and secure digital platforms. From custom web applications to eCommerce solutions and enterprise portals, our expert team delivers scalable architectures and seamless user experiences that drive growth and engagement. With modern frameworks and agile methodologies, we build future-proof websites that elevate your brand and meet your business objectives.',
    icon: <FaGlobe />,
    color: 'orange',
     link: '/web-development',
  },
  {
    title: 'Design Services',
    description:
      'Transforming Ideas into Visual Excellence. At Infograins, we offer top-notch design services focused on delivering visually stunning and user-centric digital experiences. From UI/UX design to brand identity, web and mobile interface designs, our creative solutions are crafted to enhance usability, boost engagement, and reflect your brand\'s vision with precision and style.',
    icon: <FaPalette />,
    color: 'orange',
      link: '/design',
  },
  {
    title: 'AI & ML Development',
    description:
      'Empowering Intelligent Automation with AI & Machine Learning. At Infograins, we deliver advanced AI and ML development services designed to transform data into actionable insights, automate processes, and enhance decision-making. From predictive analytics to natural language processing and custom machine learning models, we build intelligent systems that drive innovation, efficiency, and competitive advantage across industries.',
    icon: <FaBrain />,
    color: 'orange',
       link: '/ai-development-services',
  },
  {
    title: 'IoT Services',
    description:
      'Connecting Intelligent Ecosystems with IoT Innovation. At Infograins, we deliver cutting-edge IoT services that transform businesses through intelligent automation, real-time insights, and connected device ecosystems. From smart home integrations to industrial IoT and custom sensor-based solutions, we build scalable and secure systems that unlock the full potential of data-driven decision-making and operational efficiency.',
    icon: <FaWifi />,
    color: 'orange',
    link:'/iot/iot-app'
  },
  {
    title: 'Salesforce Solutions',
    description:
      'Transforming Business Efficiency with Salesforce Expertise. At Infograins, we deliver powerful Salesforce solutions designed to enhance customer engagement, automate workflows, and drive measurable growth. From CRM customization to Salesforce integration and cloud migration, we develop tailored strategies that unlock your business potential through scalable, intelligent, and results-driven platforms.',
    icon: <FaSalesforce />,
    color: 'orange',
    link:'/salesforce-solutions/development'
  },
  {
    title: 'Software Testing Solutions',
    description:
      'Ensuring Seamless Performance with Expert Testing Services. At Infograins, we offer comprehensive software testing solutions designed to ensure your applications perform flawlessly across platforms and conditions. From manual and automated testing to performance, security, and usability assessments, we deliver quality assurance at every development stage. Our expert QA engineers use the latest tools and methodologies to detect bugs, enhance functionality, and guarantee a smooth user experience that meets your business objectives.',
    icon: <FaBug />,
    color: 'orange',
     link: '/software-testing',
  },
  {
    title: 'Game Services',
    description:
      'Building Immersive Digital Experiences with Custom Game Development. At Infograins, we offer top-tier game development services designed to turn your creative ideas into engaging and visually stunning digital experiences. From mobile games and AR/VR environments to blockchain-integrated gaming solutions, our expert developers deliver interactive, scalable, and performance-driven games tailored to your target audience and platform.',
    icon: <FaGamepad />,
    color: 'orange',
     link: '/game-development',
  },
];

export default function ServicesSection() {
  const [activeIndex, setActiveIndex] = useState(0);

  return (
    <div className="services-wrapper">
      <section className="services-container">
        {/* Header Section */}
        <header className="services-header">
          <h2 className="services-main-title">
            Our <span className="gradient-text">Services</span>
          </h2>
          <p className="services-subtitle">
            Comprehensive software solutions tailored to transform your business vision into reality
          </p>
        </header>

        {/* Main Services Content */}
        <div className="services-main">
          {/* Sidebar Navigation */}
          <aside className="services-sidebar">
            <div className="sidebar-header">
              <h3 className="sidebar-title">
                <div className="pulse-dot"></div>
                Choose a Service
              </h3>
            </div>
            
            <nav className="services-nav">
              {services.map((service, index) => (
                <button
                  key={index}
                  className={`services-tab ${index === activeIndex ? 'active' : ''}`}
                  onClick={() => setActiveIndex(index)}
                  data-color={service.color}
                >
                  <div className="tab-content">
                    <span className="services-index">
                      {String(index + 1).padStart(2, '0')}.
                    </span>
                    
                    <div className="tab-info">
                      <h4 className="services-title">{service.title}</h4>
                      {/* <div className="tab-icon">{service.icon}</div> */}
                    </div>
                    
                    <FaChevronRight className="chevron-icon" />
                  </div>
                </button>
              ))}
            </nav>
          </aside>

          {/* Content Display */}
          <article className="services-content">
            <div className="content-inner">
              {/* Service Icon */}
              <div className="services-icon-container">
                <div className={`services-icon ${services[activeIndex].color}`}>
                  {services[activeIndex].icon}
                </div>
                <div className="icon-glow"></div>
              </div>

              <div className="content-header">
                <h2 className="content-title">
                  {services[activeIndex].title}
                </h2>
                <div className={`title-underline ${services[activeIndex].color}`}></div>
              </div>

              <p className="content-description">
                {services[activeIndex].description}
              </p>

              <div className="content-actions">
                <button className={`cta-button ${services[activeIndex].color}`}
                 onClick={() => window.location.href = services[activeIndex].link}>
                  <span>Learn More</span>
                  <FaArrowRight className="cta-icon" />
                </button>
              </div>

              <div className="progress-indicators">
                {services.map((_, index) => (
                  <div
                    key={index}
                    className={`progress-dot ${index === activeIndex ? 'active' : ''} ${services[activeIndex].color}`}
                  />
                ))}
              </div>
            </div>
          </article>
        </div>

        <div className="bg-decorations">
          <div className="bg-circle bg-circle-1"></div>
          <div className="bg-circle bg-circle-2"></div>
          <div className="bg-grid"></div>
        </div>
      </section>
    </div>
  );
}